import React, { useState, useEffect } from "react";
import ApplicationContext from "./ApplicationContext";
import axios from "axios";

const ApplicationProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [permissions, setPermissions] = useState(() => {
    const savedPermissions = localStorage.getItem("permissions");
    return savedPermissions ? JSON.parse(savedPermissions) : [];
  });

  const setUserAndPermissions = (userData, userPermissions) => {
    setUser(userData);
    setPermissions(userPermissions);
  };

  return (
    <ApplicationContext.Provider value={{ user, permissions, setUserAndPermissions, auth: !!user }}>
      {children}
    </ApplicationContext.Provider>
  );
};

export default ApplicationProvider;
